/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import TasksPublicService from 'mt-react-common/modules/tasks/services/TasksPublicService';
import {getItemFromRefList} from "../../../../mt-react-common/modules/main/reducers/static/states/referenceLists/reducer";
import connect from 'react-redux/es/connect/connect';
import MediumPreLoader from "../../../Common/PreLoaders/MediumPreLoader";

// eslint-disable-next-line react/prefer-stateless-function
class TimeTargetOptionsPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time_target_info: null
    };
  }

  componentDidMount() {
    TasksPublicService.getTimeTargetInfo(this.props.id).then(response => {
      this.setState({time_target_info: response.data})
    });
  }

  render() {
    let spentAmountDesc = null;
    if (
      this.state.time_target_info &&
      this.state.time_target_info.spent_amount !== null
    ) {
      if (this.state.time_target_info.spent_amount > 0) {
        spentAmountDesc = (
          <div className="alert alert-success text-center">
            На текущий период доступно{' '}
            {this.state.time_target_info.spent_amount} из{' '}
            {this.state.time_target_info.max_amount} выполнений.
          </div>
        );
      } else if (this.state.time_target_info.spent_amount <= 0) {
        spentAmountDesc = (
          <div className="alert alert-warning text-center">
            На текущий период все{' '}
            {this.state.time_target_info.max_amount} из{' '}
            {this.state.time_target_info.max_amount} позиций заняты.
          </div>
        );
      }
    }

    let result;
    if(!this.state.time_target_info){
      result = <MediumPreLoader />;
    } else {
      result = (
        <React.Fragment>
          {this.state.time_target_info.time_target_settings &&
          this.state.time_target_info.time_target_settings.map((item, index) => (
            <div
              key={`${this.props.id}-${index + 1}`}
              className="panel panel-heading_padding-large panel-default m-b-20"
              id="periodTime0"
            >
              <div className="panel-heading panel-inner-border-bottom">
                <p className="form-control-static">
                  {item.weekdays
                    .map(v => this.props.weekdays[v])
                    .join(', ')}{' '}
                </p>
              </div>
              <div className="panel-body">
                <label className="control-label">
                  Время выполнения:
                </label>
                {item.times.map((v, i) => (
                  <div
                    key={`${this.props.id}-${index + 1}-${i + 1}`}
                    className="form-inline text-nowrap form-inline_no-breakpoint"
                  >
                    <p className="form-control-static p-b-0">
                      {`${i + 1}. ${v.time_from} - ${v.time_to}`}{' '}
                      {v.max_amount ? (
                        <span className="text-muted">
                                  Максимум <strong>{v.max_amount}</strong>{' '}
                          выполнений
                                </span>
                      ) : (
                        <span className="text-muted">
                                  Без ограничений
                                </span>
                      )}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
          {spentAmountDesc}
        </React.Fragment>
      )
    }
    return (
      <React.Fragment>
        <div className="modal-dialog modal-gray modal-sm">
          <div className="modal-content">
            <div className="modal-header text-center">
              <a
                aria-label="Close"
                className="close close-black"
                data-dismiss="modal"
                href=""
              />
              <i className="fa fa-clock-o modal-icon" />
              <h4 className="modal-title">
                <strong>Таргетинг по времени</strong>
              </h4>
            </div>
            <div className="modal-body p-b-0">
              {result}
            </div>
            <div className="modal-footer">
              <a
                className="btn btn-muted"
                data-dismiss="modal"
                href=""
                type="button"
              >
                Закрыть
              </a>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

TimeTargetOptionsPopUp.defaultProps = {
  checkAccessMessage: null
};

TimeTargetOptionsPopUp.propTypes = {
  id: PropTypes.string.isRequired,
  task_id: PropTypes.number.isRequired,
  weekdays: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  weekdays: getItemFromRefList(state, 'weekdays')
});

export default withRouter(connect(mapStateToProps)(TimeTargetOptionsPopUp));



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/TimeTargetOptionsNewPopUp/index.js